// Module
var code = "<div class=\"error\"> <img ng-src=\"{{errorImg}}\"/> <div class=\"error_msg\" ng-if=\"!errorMsg\">{{errorMsg}}</div> <div class=\"error_msg\" ng-if=\"errorMsg\">{{errorMsg}} ({{errorCode}})</div> </div>";
// Exports
module.exports = code;


//////////////////
// WEBPACK FOOTER
// ./public/hws/js/error/views/content.html
// module id = 264
// module chunks = 0